export default {
  appName: "CurlyScan",
  loading: "Cargando...",
  error: "Ocurrió un error",
  save: "Guardar",
  cancel: "Cancelar",
  delete: "Eliminar",
  edit: "Editar",
  submit: "Enviar",
  success: "Éxito",
  failed: "Error",
  emailValidated: "¡Email Validado Exitosamente!",
  emailValidatedDescription: "Tu email ha sido validado exitosamente. Ahora puedes acceder a CurlyScan. Serás redirigido a la página de inicio de sesión en unos segundos.",
  goToLogin: "Ir al Login",
  login: "Iniciar Sesión",
  logout: "Cerrar Sesión",
  profile: "Perfil",
  settings: "Configuración",
  myReviews: "Mis Reseñas"
};